// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/menu/menu.js#1 $
'use strict';
angular.module('tc.menu', [])
/**
* @ngdoc component
* @name tcApp.component:tcMenu
* @description
* A resuable menu component that allows any level of nested sub-menus
*/
.component('tcMenu', {
	bindings: {
		tcMenuObject: '<',
		tcMenuHideRoot: '<',
		tcMenuExpanded: '<',
		tcMenuParent: '<',
		tcMenuGlobalStrings: '<',
		tcMenuRootId: '@',
		tcMenuOnClick: '&',
		tcMenuOnKeyPress: '&',
		tcMenuOnChangeHandler: '&',
		tcMenuComponentItem: '<',

	},
	controller: 'tcMenuCtrl',
	templateUrl: 'template/menu/menu.html'
})
.controller('tcMenuCtrl', function($window, $mdUtil, $mdMedia, $mdSidenav, $location, $q, $log,
									tcConstants, WorkflowService, MenuService, PerformanceService, GlobalService) {
	var $ctrl = this;
	
	$ctrl.$onInit = function() {
		if (angular.isUndefined($ctrl.tcMenuObject)) {
			$log.debug('Menu could not be initialised: ', $ctrl.tcMenuRootId);
			return;
		}
		$ctrl.viewModel = {
			hideError: false,
			collapsed: ((!$ctrl.tcMenuExpanded) && (($ctrl.tcMenuObject.level > 0) || (!$ctrl.tcMenuHideRoot))),
			isSubMenu: (((!$ctrl.tcMenuHideRoot) && ($ctrl.tcMenuObject.level > 0)) || ($ctrl.tcMenuObject.level > 1)),
			isVisible: (($ctrl.tcMenuObject.level > 0) || (!$ctrl.tcMenuHideRoot)),
			isDisabled: $ctrl.tcMenuObject.isDisabled
		};
		
		if ((angular.isDefined($ctrl.tcMenuObject)) && (angular.isDefined($ctrl.tcMenuObject.responsiveDisplay))) {
			toggleMenuForScreenSize();
			angular.element($window).on('resize', $ctrl.toggleMenuOnResize);
		}
	};
	
	$ctrl.$onDestroy = function() {
		angular.element($window).off('resize', $ctrl.toggleMenuOnResize);
	};
	
	// Hides the displayed error message 
	$ctrl.hideError = function() {
		$ctrl.viewModel.hideError = true;
	};
	
	// Navigates to the menu
	$ctrl.navMenu = function($event, menu) {
		$window.sessionStorage.chartbookToggled = '';
		if (menu.subMenus) {
			$ctrl.viewModel.collapsed = !$ctrl.viewModel.collapsed;
			$event.stopPropagation();

			//trigger OnChangeJSfunction when expanding/collapsing menu
			var changeHandler = $ctrl.tcMenuOnChangeHandler;
			while (angular.isFunction(changeHandler)) {
				changeHandler = changeHandler({$event: $event,menu: menu});
			}
				
			return;
		}
		var clickHandler = $ctrl.tcMenuOnClick;
		
		while (angular.isFunction(clickHandler)) {
			if (angular.isDefined(menu.selectedSubMenuName)) {			
				// deselect all the selectedSubMenuName
				if (angular.isDefined($ctrl.tcMenuParent) && angular.isDefined($ctrl.tcMenuParent.subMenus)) {
					for (var i = 0; i < $ctrl.tcMenuParent.subMenus.length; i++) {
						if (angular.isDefined($ctrl.tcMenuParent.subMenus[i].selectedSubMenuName)) {
							$ctrl.tcMenuParent.subMenus[i].selectedSubMenuName = '';
						}
					}
				}
				// set the new selectedSubMenuName
				menu.selectedSubMenuName = $ctrl.tcMenuObject.name;
			}

			clickHandler = clickHandler({$event: $event,menu: menu});
		}
		if ((!angular.isFunction(clickHandler)) && ($ctrl.tcMenuComponentItem)) {
			var linkUrl = menu.linkUrl;
			if (linkUrl) {
				if (menu.externalUrl) {
					GlobalService.openWindow(linkUrl, menu.name, menu.windowSpecs);
					return;
				}
				WorkflowService.mainMenuData = {caption: menu.caption};
				linkUrl = linkUrl 
					+ (linkUrl.indexOf('?') > -1 ? '&' : '?') + 'Dialog=0';
				PerformanceService.onMenu(menu.id);
				$location.url(linkUrl);
			}
		}
		
		$mdSidenav('mainMenu').close();
	};
	
	// Catch keydown event and call function on parent scope (e.g. actionMenu or MainMenu)
	$ctrl.onKeyPress = function($event, parentMenu, currentMenu, collapsed, rootId) {
		if ($event.keyCode === tcConstants.KEY_CODE.ENTER) {
			if (!currentMenu.isDisabled) {
				$ctrl.navMenu($event, parentMenu.subMenus[currentMenu.subMenuIndex]);
			}	
		} else {
			var keyPress = $ctrl.tcMenuOnKeyPress;
			while (angular.isFunction(keyPress)) {
				var params = {
					$event: $event,
					parentMenu: parentMenu,
					currentMenu: currentMenu,
					collapsed: collapsed,
					rootId: rootId
				};	
				keyPress = keyPress(params);
			}
			if (!angular.isFunction(keyPress)) {
				if (($event.keyCode === tcConstants.KEY_CODE.DOWN_ARROW) || ($event.keyCode === tcConstants.KEY_CODE.UP_ARROW)) {
					$event.preventDefault();
					if (angular.isUndefined(parentMenu)) parentMenu = $ctrl.viewModel.menu;
					MenuService.handleMenuKeydown($event, $ctrl.viewModel.menu, parentMenu,
													currentMenu, collapsed, rootId, $event.keyCode);
				}
			}
		}
	};
	
	// Given a 'Responsive Display' setting, determines whether menu should be visible for the current screen size
	var isVisibleForScreenSize = function(responsiveDisplay) {
		if (responsiveDisplay.indexOf('gt-') === 0) {
			return $mdMedia(responsiveDisplay);
		} else if (responsiveDisplay.indexOf('hide-') === 0) {
			return !$mdMedia(responsiveDisplay.split('hide-')[1]);
		}
		return true;
	};
	
	// Toggles the menus based on the window size
	var toggleMenuForScreenSize = function() {
		$ctrl.viewModel.isVisible = isVisibleForScreenSize($ctrl.tcMenuObject.responsiveDisplay);
	};
	
	// Toggles the menu on resize
	$ctrl.toggleMenuOnResize = $mdUtil.debounce(toggleMenuForScreenSize, 15);
})
.factory('MenuService', function($window, tcConstants) {
	// Allows navigation of the menu via the arrow keys
	var handleMenuKeydown = function($event, viewModelMenu, parentMenu, currentMenu, collapsed, rootId, keyCode) {
		if (parentMenu) {
			var menuIdPrefix = rootId + '-menu-';
			var nextMenuElementId = '';
			if (keyCode === tcConstants.KEY_CODE.DOWN_ARROW) {
				if ((collapsed) || (!currentMenu.subMenus)) {
					if (parentMenu.subMenus[currentMenu.subMenuIndex + 1]) {
						// move to next sibling
						nextMenuElementId = menuIdPrefix + parentMenu.subMenus[currentMenu.subMenuIndex + 1].name;
					} else if (viewModelMenu.subMenus[parentMenu.subMenuIndex + 1]) { 
						// at bottom of subMenu, move to next menu one level up
						nextMenuElementId = menuIdPrefix + viewModelMenu.subMenus[parentMenu.subMenuIndex + 1].name; 
					} else {
						// at bottom of last subMenu, wrap to top
						nextMenuElementId = menuIdPrefix + viewModelMenu.subMenus[0].name;	
					}
				} else {
					// at expanded menu, move to first subMenu
					nextMenuElementId = menuIdPrefix + currentMenu.subMenus[0].name;
				}
			} else if (keyCode === tcConstants.KEY_CODE.UP_ARROW) {
				if (((currentMenu.subMenuIndex - 1) >= 0) && (parentMenu.subMenus[currentMenu.subMenuIndex - 1])) {
					// try to find last subMenu of previous Sibling
					var previousSiblingMenu = parentMenu.subMenus[currentMenu.subMenuIndex - 1];
					if (previousSiblingMenu.subMenus) {
						nextMenuElementId = menuIdPrefix + previousSiblingMenu.subMenus[previousSiblingMenu.subMenus.length - 1].name;
						if (!$window.document.getElementById(nextMenuElementId)) {
							// subMenus hidden, go to previous at this level
							nextMenuElementId = menuIdPrefix + parentMenu.subMenus[currentMenu.subMenuIndex - 1].name;
						}
					} else {
						// prev sibling has no subMenus, go to previous at this level
						nextMenuElementId = menuIdPrefix + parentMenu.subMenus[currentMenu.subMenuIndex - 1].name;
					}
				} else if (angular.isDefined(parentMenu.subMenuIndex)) { 
					// at top of submenu, move to parent
					nextMenuElementId = menuIdPrefix + parentMenu.name;
				} else {
					// at top, find last visible menu to wrap to bottom
					var lastVisibleSubMenu = parentMenu.subMenus[parentMenu.subMenus.length - 1];
					if (lastVisibleSubMenu.subMenus) {
						var lastNestedSubMenu = lastVisibleSubMenu.subMenus[lastVisibleSubMenu.subMenus.length - 1];
						var lastNestedSubMenuId = menuIdPrefix + lastNestedSubMenu.name;
						if ($window.document.getElementById(lastNestedSubMenuId)) {
							lastVisibleSubMenu = lastNestedSubMenu;
						}
					}
					nextMenuElementId = menuIdPrefix + lastVisibleSubMenu.name;	
				}
			}
			
			// focus next element
			if (nextMenuElementId !== '') {
				var nextFocusElement = $window.document.getElementById(nextMenuElementId);
				if (nextFocusElement) {
					nextFocusElement.focus();	
				}
			}
		}
			
	};
	
	return {
		handleMenuKeydown: handleMenuKeydown
	};

});
